export default {
  panel: {
    borderWidth: '0',
    first: {
      borderWidth: '0',
    },
    last: {
      borderWidth: '0',
    },
  },
};
